import type { ReactElement } from "react";
import { useMemo } from "react";

import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/common-components/filters-panel/constants";
import { FilterChipVariant } from "app/pages/sales-intelligence/common-components/filters-panel/types/commonEnums";
import type { IAppListedAddressFilterDto } from "app/pages/sales-intelligence/store/find-apps/types";
import CountryService from "app/services/CountryService";

import { StyledListedAddressResultContainer } from "./styles";

const ListedAddressFilterResult = ({
    value,
    onFilterUpdate,
    isExpanded,
}: IFilterViewBaseModelProps<IAppListedAddressFilterDto>): ReactElement | null => {
    const handleClose = (id: string) => {
        const countryId = Number(id);
        const countries = value?.countries.filter((item: number) => item !== countryId);
        onFilterUpdate(countries && countries.length > 0 ? { ...value, countries } : undefined);
    };

    const chipItems: ChipItem[] = useMemo(() => {
        return value?.countries && value.countries.length > 0
            ? value?.countries.map((item: number) => {
                  const country = CountryService.getCountryById(item);
                  return {
                      id: country.id.toString(),
                      variant: FilterChipVariant.Country,
                      text: country.text,
                  };
              })
            : [];
    }, [value]);

    if (!value || value.countries.length === 0) {
        return null;
    }

    return (
        <StyledListedAddressResultContainer>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleClose}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                isTabExpanded={isExpanded}
            />
        </StyledListedAddressResultContainer>
    );
};

export default ListedAddressFilterResult;
